/* ==========================================================================
   UiPopper > Client > Button
   ========================================================================== */
/* Modules */
const { html } = require('common-tags');
const { toNode } = require('@bluekiri/alexandria/helpers/domHelpers');
const { createPopper } = require('@popperjs/core/lib/popper');
const vendorConfig = require('../vendor/config');

function addPopper(instance) {
    const result = instance;

    const {
        css = {},
        content = '',
        placement,
        arrow,
        arrowPadding,
        offset,
        hasClick,
        hasContentSelectable,
        contentSelectableStyle
    } = instance.config;

    const arrowPartial = arrow ? html(`<span class='${css.arrow}' data-uipopper-arrow></span>`) : '';
    const popperTemplate = html(
        `<span class='${css.popper}' data-uipopper-content>
            ${content}
            ${arrowPartial}
        </span>`
    );

    /* Add popper */
    const node = toNode(popperTemplate)[0];
    instance.element.appendChild(node);

    // when event if over make popper selectable
    const setContentSelectable = data => {
        const element = document.createElement('span');

        element.style.cssText = `position: absolute; ${contentSelectableStyle}`;
        data.elements.popper.appendChild(element);
    };

    result.popper = createPopper(instance.element, node, {
        ...vendorConfig({ placement, offset, arrow, arrowPadding })
    });

    result.popper.update().then(data => {
        if (hasContentSelectable && !hasClick) setContentSelectable(data);
    });
}

function destroyPopper(instance) {
    const result = instance;

    if (instance.popper) {
        instance.popper.destroy();
        instance.popper.state.elements.popper.remove();
        delete result.popper;
    }
}

/* Exports */
module.exports = {
    addPopper,
    destroyPopper
};
